import React, { FC } from 'react'
import Layout from '../../layouts/layout'
import { Modules } from './modules'

//* styles
import '../../../../static-cdn/css/raw-html-common.css'

//* utils
import { LocaleCodes } from '../../../constants/localization.constants'
import { ComponentFeaturedSlider } from '../../../models/components/featuredSlider'
import { ComponentMainNavBanner } from '../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../models/others/menuGroup'
import headerStaticQuery from '../../global/header/headerStaticQuery'

type Props = {
  path: string
  pageContext: any
  location?: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  mainNavBannerData?: ComponentMainNavBanner
  featuredSliderData: ComponentFeaturedSlider | null
}

const RawHTMLPage: FC<Props> = ({
  path,
  pageContext,
  location,
  headerData,
  mainNavBannerData,
  featuredSliderData,
}) => {
  if (!pageContext.data) return null
  const { slug, footer, header } = pageContext.data
  const defaultLocale = pageContext?.pageLocale || LocaleCodes.ENGLISH.code

  const headerStaticQueryData = headerData || headerStaticQuery.allContentfulNavMenu()
  const microcopySet =
    headerStaticQueryData && 'allContentfulMicrocopySet' in headerStaticQueryData
      ? headerStaticQueryData.allContentfulMicrocopySet
      : null

  const headerInfo = header
    ? {
        allContentfulNavMenu: {
          nodes: [header],
        },
        allContentfulMicrocopySet: microcopySet,
      }
    : null

  const footerInfo = footer
    ? {
        allContentfulNavMenu: {
          nodes: [footer],
        },
      }
    : null

  return (
    <Layout.Template
      lang={defaultLocale}
      slug={slug}
      headerData={headerInfo}
      footerData={footerInfo}
      showHeader={!!header}
      showFooter={!!footer}
      mainNavBannerData={mainNavBannerData}>
      <Modules
        data={pageContext.data}
        locale={defaultLocale}
        path={path}
        featuredSlider={featuredSliderData}
        location={location}
      />
    </Layout.Template>
  )
}

export default RawHTMLPage
